<template>
    <div class="columns is-centered is-multiline has-text-centered">
        <div class="column is-12 has-text-right">
            <div class="field mr-3">
                <div class="control">
                    <label class="mr-2"
                        >Recarga en {{ reloadCountdown }} segundos</label
                    >
                    <button
                        class="button is-primary"
                        @click="reload"
                        :disabled="isLoading"
                    >
                        <Icon family="fal" name="fa-sync" />
                    </button>
                </div>
            </div>
        </div>
        <div class="column is-5">
            <h5 class="is-primary is-uppercase has-text-weight-medium p-2">
                Operadores del sistema
            </h5>
            <div class="columns is-centered p-4">
                <div class="column is-3 banner">
                    <p class="number">{{ totalOperators }}</p>
                    <p class="text">Total</p>
                </div>
                <div class="column is-3 banner">
                    <p class="number">{{ kpi.disconnected }}</p>
                    <p class="text">Desconectados</p>
                </div>
                <div class="column is-3 banner">
                    <p class="number">{{ kpi.connected }}</p>
                    <p class="text">Disponibles</p>
                </div>
                <div class="column is-3 banner">
                    <p class="number">{{ kpi.onRoom }}</p>
                    <p class="text">En llamada</p>
                </div>
            </div>
        </div>
        <div class="column is-1"></div>
        <div class="column is-5">
            <h5 class="is-primary is-uppercase has-text-weight-medium p-2">
                Llamadas en el día de hoy
            </h5>
            <div class="columns is-centered p-4">
                <div class="column is-3 banner">
                    <p class="number">{{ kpi.served }}</p>
                    <p class="text">Atendidas</p>
                </div>
                <div class="column is-3 banner">
                    <p class="number">{{ kpi.abandoned }}</p>
                    <p class="text">Abandonadas</p>
                </div>
                <div class="column is-3 banner">
                    <p class="time">{{ parseTime(kpi.averageTime) }}</p>
                    <p class="text">Tiempo medio</p>
                </div>
            </div>
        </div>

        <div class="column is-11">
            <div class="field has-addons is-justify-content-flex-end">
                <div class="control mt-2 mr-2">
                    <label class="label">Búsqueda: </label>
                </div>
                <div class="control">
                    <input v-model="search" type="text" class="input" />
                </div>
                <div class="control">
                    <button
                        class="button is-danger has-text-weight-medium"
                        @click="search = ''"
                        :disabled="search === ''"
                    >
                        X
                    </button>
                </div>
            </div>
        </div>
        <div class="column is-6">
            <h5 class="is-primary is-uppercase has-text-weight-medium p-2 mt-3">
                Skills de los operadores disponibles
            </h5>
            <Skills :skills="connectedFilteredSkills" />
        </div>
        <div class="column is-6">
            <h5 class="is-primary is-uppercase has-text-weight-medium p-2 mt-3">
                Skills de los operadores
            </h5>
            <Skills :skills="filteredSkill" />
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import Skills from "./Skills.vue";

export default {
    name: "operators-kpi",
    components: {
        Skills,
    },
    props: {
        signalRSocket: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLoading: true,
            kpi: {},
            search: "",

            reloadCountdown: 60,
            reloadTimer: null,
        };
    },
    mounted() {
        this.retrieveData();
        this.signalRSocket.on("OperatorJoined", this.operatorJoined);
        this.signalRSocket.on("OperatorLeaved", this.operatorLeaved);
    },
    beforeDestroy() {
        this.stopTimer();
    },
    computed: {
        totalOperators() {
            let kpi = this.kpi;
            if (kpi.disconnected === undefined) {
                return "-";
            }
            return kpi.disconnected + kpi.connected + kpi.onRoom;
        },
        skills() {
            return this.kpi.groupedSkills;
        },
        filteredSkill() {
            let skills = this.skills;
            if (skills === undefined) {
                return [];
            }
            let search = this.search.toLowerCase();
            return skills
                .sort((a, b) => b.count - a.count)
                .filter((s) => s.id.toLowerCase().indexOf(search) > -1);
        },
        connectedFilteredSkills() {
            var connectedSkills = this.kpi.connectedGroupedSkills;
            if (connectedSkills === undefined) {
                return [];
            }
            let search = this.search.toLowerCase();
            return connectedSkills
                .sort((a, b) => b.count - a.count)
                .filter((s) => s.id.toLowerCase().indexOf(search) > -1);
        },
    },
    methods: {
        startTimer() {
            this.reloadTimer = setInterval(() => {
                this.reloadCountdown--;
                if (!this.isLoading && this.reloadCountdown === 0) {
                    this.reloadCountdown = 60;
                    this.retrieveData();
                } else if (this.reloadCountdown <= 0) {
                    this.reloadCountdown = 60;
                }
            }, 1000);
        },
        stopTimer() {
            this.reloadCountdown = 60;
            clearInterval(this.reloadTimer);
        },
        operatorJoined() {
            this.retrieveData();
        },
        operatorLeaved() {
            this.retrieveData();
        },
        reload() {
            this.retrieveData();
        },
        async retrieveData() {
            this.stopTimer();
            this.isLoading = true;

            let response = await RepositoryFactory.operators.kpi();
            this.kpi = response.data;

            this.isLoading = false;
            this.startTimer();
        },
        parseTime(timespan) {
            if (timespan === undefined) {
                return "-";
            }
            var response = "";
            var time = timespan.split(".")[0];
            var minutes = parseInt(time.split(":")[1]);
            if (minutes > 0) {
                response += `${minutes}min`;
            }
            var seconds = parseInt(time.split(":")[2]);
            if (seconds > 0) {
                response += ` ${seconds}s`;
            }
            return response.trim();
        },
    },
};
</script>

<style lang="scss" scoped>
.banner {
    margin: 1rem 2rem;

    .number {
        font-size: 3rem;
        font-weight: bold;
        margin-right: 0rem;
    }

    .text {
        font-size: 1.25rem;
    }

    .time {
        font-size: 2rem;
        font-weight: bold;
        margin-right: 0rem;
        margin-top: 1.5rem;
    }
}
</style>